module.exports = __webpack_public_path__ + "img/pics_quick-easy-nav.3962bd1e.svg";